import React from 'react';
import AnalyticsPageLayout from '../components/analytics/AnalyticsPageLayout';
import SurveyResponsesAnalytics from '../components/SurveyResponsesAnalytics';
import SponsoredCohortSurveyRawData from '../components/SponsoredCohortSurveyRawData';

const TABS = [
  { title: 'Survey responses', component: <SurveyResponsesAnalytics /> },
  {
    title: 'Learners who submitted',
    component: <SponsoredCohortSurveyRawData />,
  },
];

export default function CohortSurveyAnalytics() {
  return (
    <AnalyticsPageLayout
      title="Cohort Survey Analytics"
      description="Weekly survey responses, segmented by cohort."
      tabs={TABS}
    />
  );
}
